import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiArrowRight } from 'react-icons/fi';
import { GiCrystalBall } from 'react-icons/gi';
import { useHydrated } from '../../hooks/useHydrated';
import { useTranslation } from '../../hooks/useTranslation';
import './CTASection.css';

const CTASection = () => {
  const hydrated = useHydrated();
  const { t } = useTranslation();
  return (
    <section className="cta-section">
      <div className="cta-bg-elements">
        <div className="cta-circle circle-1"></div>
        <div className="cta-circle circle-2"></div>
        <div className="cta-stars"></div>
      </div>

      <div className="container">
        <motion.div
          className="cta-content"
          initial={hydrated ? { opacity: 0, y: 30 } : false}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="cta-icon">
            <GiCrystalBall />
          </div>
          <h2>{t('cta.title')}</h2>
          <p>{t('cta.subtitle')}</p>

          <div className="cta-buttons">
            <Link to="/online-horoscope-generator" className="btn btn-primary btn-lg">
              <FiArrowRight /> {t('cta.freeHoroscope')}
            </Link>
            <Link to="/zodiac" className="btn btn-secondary btn-lg">
              <FiArrowRight /> {t('cta.exploreZodiac')}
            </Link>
          </div>

          <div className="cta-features">
            <div className="cta-feature">
              <span className="feature-check">✓</span>
              <span>{t('cta.feature1')}</span>
            </div>
            <div className="cta-feature">
              <span className="feature-check">✓</span>
              <span>{t('cta.feature2')}</span>
            </div>
            <div className="cta-feature">
              <span className="feature-check">✓</span>
              <span>{t('cta.feature3')}</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
